// Global Init

// Tab Settings
const allCatStudyNavsMeta = document.querySelectorAll('.js-study-categories-meta')
allCatStudyNavsMeta.forEach(studyNav => {
    studyNav.addEventListener('click', e => {
        const clickedSlide = e.target
        const study = clickedSlide.dataset.study
        const allButtons = studyNav.querySelectorAll('.js-scientific-study-meta-tab')
        const container = clickedSlide.closest('.js-scientific-studies-meta')

        // Remove "is_active" on all buttons
        allButtons.forEach(btn => {
            if (btn.classList.contains('is_active')) {
                btn.classList.remove('is_active')
            }
        });

        // Add "is_active" to clicked slide
        if (clickedSlide.classList.contains('is_active') === false) {
            clickedSlide.classList.add('is_active')
        }

        // Hide all scientific study sliders
        const allScientificStudySliders = container.querySelectorAll('.js-scientific-study-meta_wrapper')
        allScientificStudySliders.forEach(scientificStudySlider => {
            scientificStudySlider.style.display = "none";
        });

         // Show relevant scientific study
        container.querySelector(`#${study}`).style.display = "block";
    })
});

// Open all study links in new tabs
const studyDescriptionsMeta = document.querySelectorAll('.js-studies-text-meta')
studyDescriptionsMeta.forEach(description => {
    
    description.addEventListener('click', e => {
        e.preventDefault()
        const link = e.target.closest('a')
        if (link !== null) {
            const url = link.href
            window.open(url, '_blank').focus();
        }
    })
});

// Slider without Headings or Tabs
const NoHeadingSwiperMeta = new Swiper('.NoHeadingSwiperMeta', {
    loop: true,
    autoHeight: true,
    disableOnInteraction: false, 
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
        el: '.NoHeadingSwiperMeta__swiper-pagination-meta',
        type: 'bullets', 
        clickable: true,
    },
    navigation: {
        nextEl: ".js-next__NoHeadingSwiperMeta",
        prevEl: ".js-prev__NoHeadingSwiperMeta",
    },
});

// Slider without categories
const noCatSwiperMeta = new Swiper('.js-scientific-studies-meta-sliders', {
    loop: true,
    autoHeight: true,
    disableOnInteraction: false, 
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
        el: '.js-all-sliders-meta__swiper-pagination-meta',
        type: 'bullets', 
        clickable: true,
    },
    navigation: {
        nextEl: ".js-next__scientific-studies-meta",
        prevEl: ".js-prev__scientific-studies-meta",
    },
});

// Sliders with Headings or Tabs
const allScientificStudyTabsMeta = document.querySelectorAll('.js-scientific-studies-meta-tabs')
allScientificStudyTabsMeta.forEach(slider => {
    const handle = slider.dataset.sliderHandle
    const sliderClass = slider.dataset.sliderClass 

    const swiper = new Swiper(`.${sliderClass}`, {
        loop: true,
        autoHeight: true,
        disableOnInteraction: false, 
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: `.${handle}__swiper-pagination-meta`,
            type: 'bullets', 
            clickable: true,
        },
        navigation: {
            nextEl: `.js-next__${handle}`,
            prevEl: `.js-prev__${handle}`,
        },
    });

});
